@if (epm.text$ | async; as text) {
  <div class="cookies">
    <div class="cookies-inner">
      <span>{{ 't.we-use' | translate }}
        <span class="pointer" (click)="goToPolicy()">
          {{ 'link.cookies' | translate }}
        </span> <br>
      </span>
      <span [innerHTML]="text"></span>
    </div>
    <span class="pointer pointer-au" (click)="cookiesAccepted()">{{'btn.accept' | translate}}</span>
  </div>
}
